import React from 'react';

// Small reusable pill for a vehicle type — used on Fleet cards, the trip bus
// picker, and passenger search/booking result cards. Renders nothing for
// untyped/legacy buses so backward compatibility never needs special-casing.
const VehicleTypeBadge = ({ vehicleType, className = '' }) => {
  if (!vehicleType) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 ${className}`}
    >
      {vehicleType.icon && <span>{vehicleType.icon}</span>}
      <span>{vehicleType.name}</span>
    </span>
  );
};

export default VehicleTypeBadge;
